import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import jiosaavan from "./jiosaavan.jpg"
import box8 from "./box8.jpg"
import mednear from "./mednear.png"
import youtube from "./youtube.jpg"
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiChakraui,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src={jiosaavan} alt="TicTacToe" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>JioSaavan Clone</h2>
              <p>
              Clone of the popular online music streaming platform JioSaavan.A Full Stack
                project use REACT, HTML , CSS & JavaScript for front end and nodeJS on
                backend.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                <SiChakraui />
              </div>
              <div>
                <a
                  href="https://jiosaavnclone.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/tushar8342/JioSaavn-clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src={box8} alt="Zara App" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>BOX8.in Replica</h2>
              <p>
              This is the clone of Box8.in which You Order Food Online and get it delivered within 30 minutes.
              Build with the help of API.
              </p>
              <div>
                {/* <FaReact /> */}
                <SiHtml5 />
                <IoLogoJavascript />
                <SiNodedotjs />
                <SiExpress />
                <SiMongodb />
              </div>
              <div>
                <a
                  href="https://dreamy-payne-e416f2.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Gourav135/Box8-Frontend/tree/main"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={mednear}
                  alt="Weather-App"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Mednear Clone</h2>
              <p>
              An exact clone of the well-known Online Medicine site using Javascript,HTML and CSS.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://mednear.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/HrgChampion/Mednear-clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>





      <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={youtube}
                  alt="Weather-App"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>YouTube App</h2>
              <p>
              Clone of Online Video streaming Platform YouTube.com using Javascript,HTML and CSS.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://you-tube-self.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/tushar8342/YouTube"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
           
    </>
  );
};
